import React, { useLayoutEffect } from "react";
import { Outlet, useLocation, useNavigationType } from "react-router-dom";
import Navbar from "@/components/Navbar";
import { Footer } from "./Footer";
import { ChatBot } from "@/components/ChatBot";

const scrollPositions = new Map<string, number>();
const ScrollToTop: React.FC = () => {
  const { key, hash } = useLocation();
  const navigationType = useNavigationType();
  useLayoutEffect(() => {
    const previous = window.history.scrollRestoration;
    window.history.scrollRestoration = "manual";
    const restore = () => {
      if (hash) {
        document.getElementById(decodeURIComponent(hash.slice(1)))?.scrollIntoView({
          block: "start",
          behavior: "instant" as ScrollBehavior,
        });
        return;
      }
      const y = navigationType === "POP" ? scrollPositions.get(key) || 0 : 0;
      window.scrollTo({ top: y, behavior: "instant" as ScrollBehavior });
    };
    restore();
    const frame = requestAnimationFrame(restore);
    return () => {
      scrollPositions.set(key, window.scrollY);
      cancelAnimationFrame(frame);
      window.history.scrollRestoration = previous;
    };
  }, [key, hash, navigationType]);
  return null;
};

export const Layout: React.FC = () => {
  return (
    <div className="flex min-h-screen flex-col">
      <ScrollToTop />
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <ChatBot />
    </div>
  );
};

export default Layout;
